const mutations = {
	LOGIN_CUSTOMER: function(state, session_id){
		Cookies.set('user_session', session_id, { path: '/', expires: 365 });
	},
	LOGOUT_CUSTOMER: function(state){
		state.reservation.user_session = false;
		Cookies.remove('user_session');
	},

	// ------------------------ STATION ------------------------
	SET_STATIONS: function(state, data) {
		console.debug('ORM|M|SET_STATIONS', data);
		state.stations = data;
	},
	UNSET_STATIONS: function(state) {
		console.debug('ORM|M|UNSET_STATIONS');
		state.stations = [];
	},

	// ------------------------ GROUPS ------------------------
	SET_GROUPS: function(state, data) {
		console.debug('ORM|M|SET_GROUPS', data);
		state.groups = data;
	},
	UNSET_GROUPS: function(state) {
		console.debug('ORM|M|UNSET_GROUPS');
		state.groups = [];
	},

	// ------------------------ STATION ------------------------
	SET_OFFERS: function(state, data) {
		console.debug('ORM|M|SET_OFFERS', data);
		state.offers = data;
	},
	UNSET_OFFERS: function(state) {
		console.debug('ORM|M|UNSET_OFFERS');
		state.offers = [];
	},


	// ------------------------ TRANSLATIONS ------------------------
	SET_TRANSLATIONS: function(state, data) {
		console.debug('ORM|M|SET_TRANSLATIONS', data);
		state.translations = data;
	},
	UNSET_TRANSLATIONS: function(state) {
		console.debug('ORM|M|UNSET_TRANSLATIONS');
		state.translations = {};
	},
	SET_CS_TRANSLATIONS: function(state, data) {
		console.debug('ORM|M|SET_CS_TRANSLATIONS', data);
		state.cs_translations = data;
	},
	UNSET_CS_TRANSLATIONS: function(state) {
		console.debug('ORM|M|UNSET_CS_TRANSLATIONS');
		state.cs_translations = {};
	},
	SET_SALUTATIONS: function(state, data) {
		console.debug('ORM|M|SET_SALUTATIONS', data);
		state.salutations = data;
	},
	UNSET_SALUTATIONS: function(state) {
		console.debug('ORM|M|UNSET_SALUTATIONS');
		state.salutations = [];
	},



	// ------------------------ PARAMS ------------------------
	SET_PARAMS: function(state, data) {
		console.debug('ORM|M|SET_PARAMS', data);
		state.params = data;
	},
	UNSET_PARAMS: function(state) {
		console.debug('ORM|M|UNSET_PARAMS');
		state.params = [];
	},


	// ------------------------ CONFIG ------------------------
	SET_CONFIG: function(state, data) {
		console.debug('ORM|M|SET_CONFIG', data);
		state.config = data;
	},
	UNSET_CONFIG: function(state) {
		console.debug('ORM|M|UNSET_CONFIG');
		state.config = [];
	},

	// ------------------------ FOOTER NAVIGATION ------------------------
	SET_FOOTERNAVIGATION: function(state, data) {
		console.debug('ORM|M|SET_FOOTERNAVIGATION', data);
		state.footernavigation = data;
	},
	UNSET_FOOTERNAVIGATION: function(state) {
		console.debug('ORM|M|UNSET_FOOTERNAVIGATION');
		state.footernavigation = [];
	},

	SET_MAINNAVIGATION: function(state, data) {
		console.debug('ORM|M|SET_MAINNAVIGATION', data);
		state.mainnavigation = data;
	},
	UNSET_MAINNAVIGATION: function(state) {
		console.debug('ORM|M|UNSET_MAINNAVIGATION');
		state.mainnavigation = [];
	},


	SET_HOMEPAGE: function(state, data) {
		console.debug('ORM|M|SET_HOMEPAGE', data);
		state.homepage = data;
	},
	UNSET_HOMEPAGE: function(state) {
		console.debug('ORM|M|UNSET_HOMEPAGE');
		state.homepage = [];
	},
	SET_CONTACTPAGE: function(state, data) {
		console.debug('ORM|M|SET_CONTACTPAGE', data);
		state.contactpage = data;
	},
	UNSET_CONTACTPAGE: function(state) {
		console.debug('ORM|M|UNSET_CONTACTPAGE');
		state.contactpage = [];
	},

	SET_FAQ: function(state, data) {
		console.debug('ORM|M|SET_FAQ', data);
		state.faq = data;
	},
	UNSET_FAQ: function(state) {
		console.debug('ORM|M|UNSET_FAQ');
		state.faq = [];
	},

	SET_HEADERNAVIGATION: function(state, data) {
		console.debug('ORM|M|SET_HEADERNAVIGATION', data);
		state.headernavigation = data;
	},
	UNSET_HEADERNAVIGATION: function(state) {
		console.debug('ORM|M|UNSET_HEADERNAVIGATION');
		state.headernavigation = [];
	},

	

};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/orm/mutations.js